import { FormikField } from '../../../Formik'
import { RADIO_SIZE, RadioGroup } from '../../../Radio'

import * as styles from './EpostFormFieldsRadioField.module.css'

function EpostFormFieldsRadioField(props) {
  return (
    <FormikField
      {...props}
      Component={RadioGroup}
      className={styles.field}
      radioComponentProps={{
        containerProps: {
          className: styles.container,
        },
        labelProps: {
          className: styles.label,
        },
        size: RADIO_SIZE.small,
      }}
    />
  )
}

export default EpostFormFieldsRadioField
